const helper = require('../helperFunctions.js');

module.exports = function basePartial() {
  // custom Hub functions

  let baseLoaded = false;

  Hubs.Events
    .on('load', () => {
      if (!baseLoaded) {
        // Call all on load functions here

        baseLoaded = true;
      }
    })
    .on('itemsLoaded', (itemIds, selectors) => {
      // Call all itemsLoaded events here
    })
    .on('resize', () => {
      // Call all resize events here
    })
    .on('scroll', () => {
      // Call all scroll events here
    })
    .on('ctaActivate', (ctaId) => {
      // Call all ctaActivate events here
    })
    .on('ctaFormSubmitSuccess', (ctaId, mappedData, ctaName) => {
      // Call all ctaFormSubmitSuccess events here
    });
};



// WEBPACK FOOTER //
// ./scriptPartials/base/index.js